import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrderPage } from '../orderPageContext/useOrderPage';
import { useLanguage } from '../../utils/GeneralUtils';
import { getIntentConfigs } from './intentConfigs';
import { StepConditionContext, StepId } from './types';

export function useIntentConfig() {
  const { orderPageState } = useOrderPage();
  const { t } = useTranslation();
  const language = useLanguage();

  const intentConfigs = useMemo(() => getIntentConfigs(t), [t]);
  const config = intentConfigs[orderPageState.orderPageIntent];

  const visibleSteps = useMemo(() => {
    if (!config) {
      return [];
    }
    const ctx: StepConditionContext = {
      orderPage: orderPageState.orderPage,
      language,
      isStandaloneGiftCard: !!orderPageState.specificOrderPage?.standaloneGiftCard,
    };
    return config.steps.filter((step) => !step.condition || step.condition(ctx));
  }, [config, orderPageState.orderPage, orderPageState.specificOrderPage?.standaloneGiftCard, language]);

  const currentStepIndex = orderPageState.activeStep;
  const currentStepId = visibleSteps[currentStepIndex]?.id;

  const getStepIndex = useCallback((stepId: StepId) => visibleSteps.findIndex((s) => s.id === stepId), [visibleSteps]);

  return {
    config,
    visibleSteps,
    currentStepId,
    currentStepIndex,
    totalSteps: visibleSteps.length,
    getStepIndex,
  };
}
